import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './field.scss';
import { GECKO_CONSTS, GECKO_UTILS, GeckoFieldModel } from '../../';
import Badge from 'react-bootstrap/Badge';

import {
  GeckoFieldColor,
  GeckoFieldCheckbox,
  GeckoFieldCustom,
  GeckoFieldDate,
  GeckoFieldDisplay,
  GeckoFieldNumber,
  GeckoFieldPassword,
  GeckoFieldRadio,
  GeckoFieldRichtext,
  GeckoFieldSearch,
  GeckoFieldSelect,
  GeckoFieldSelectCreate,
  GeckoFieldSelectCreateMulti,
  GeckoFieldSelectMulti,
  GeckoFieldTelephone,
  GeckoFieldText,
  GeckoFieldTextarea,
  GeckoFieldToggle,
} from './types';

class GeckoField extends Component {
  // Map field types to field components
  types = {
    [GECKO_CONSTS.FIELD_TYPE_ADDRESS]: GeckoFieldText,
    [GECKO_CONSTS.FIELD_TYPE_CHECKBOX]: GeckoFieldCheckbox,
    [GECKO_CONSTS.FIELD_TYPE_COLOR]: GeckoFieldColor,
    [GECKO_CONSTS.FIELD_TYPE_CUSTOM]: GeckoFieldCustom,
    [GECKO_CONSTS.FIELD_TYPE_DATE]: GeckoFieldDate,
    [GECKO_CONSTS.FIELD_TYPE_DISPLAY]: GeckoFieldDisplay,
    [GECKO_CONSTS.FIELD_TYPE_EMAIL]: GeckoFieldText,
    [GECKO_CONSTS.FIELD_TYPE_NAME]: GeckoFieldText,
    [GECKO_CONSTS.FIELD_TYPE_NUMBER]: GeckoFieldNumber,
    [GECKO_CONSTS.FIELD_TYPE_PASSWORD]: GeckoFieldPassword,
    [GECKO_CONSTS.FIELD_TYPE_RADIO]: GeckoFieldRadio,
    [GECKO_CONSTS.FIELD_TYPE_RICH_TEXT]: GeckoFieldRichtext,
    [GECKO_CONSTS.FIELD_TYPE_SEARCH]: GeckoFieldSearch,
    [GECKO_CONSTS.FIELD_TYPE_SELECT]: GeckoFieldSelect,
    [GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE]: GeckoFieldSelectCreate,
    [GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI]: GeckoFieldSelectCreateMulti,
    [GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI]: GeckoFieldSelectMulti,
    [GECKO_CONSTS.FIELD_TYPE_TELEPHONE]: GeckoFieldTelephone,
    [GECKO_CONSTS.FIELD_TYPE_TEXT]: GeckoFieldText,
    [GECKO_CONSTS.FIELD_TYPE_TEXTAREA]: GeckoFieldTextarea,
    [GECKO_CONSTS.FIELD_TYPE_TITLE]: GeckoFieldText,
    [GECKO_CONSTS.FIELD_TYPE_TOGGLE]: GeckoFieldToggle,
    [GECKO_CONSTS.FIELD_TYPE_URL]: GeckoFieldText,
  };

  field() {
    return this.props.field;
  }

  type() {
    return this.field().type || GECKO_CONSTS.FIELD_TYPE_TEXT;
  }

  renderClasses() {
    const errors = this.errors();
    return GECKO_UTILS.classNames(
      `gecko-field gecko-field-type-${this.type()} gecko-field-key-${
        this.field().key
      } ${this.field().className} ${errors.length ? 'has-errors' : ''}`
    );
  }

  renderFor() {
    return `field_${this.field().key}`;
  }

  isRequired() {
    return (
      this.field().required ||
      (this.field().requiredWhen ? this.field().requiredWhen() : false)
    );
  }

  renderRequired() {
    if (this.isRequired()) return <span className="required">*</span>;
    return null;
  }
  isBeta() {
    return this.field().isBeta;
  }

  renderBeta() {
    if (this.isBeta()) return <Badge className="beta">Beta</Badge>;
    return null;
  }
  renderField() {
    const Field = this.types[this.type()];
    return (
      <Field
        field={this.field()}
        values={this.props.values}
        handler={this.props.handler.bind(this)}
      />
    );
  }

  renderDescription() {
    if (this.field().description) {
      return <p className="description">{this.field().description}</p>;
    }
    return null;
  }

  renderSecondaryDescription() {
    if (this.field().secondaryDescription) {
      return <p className="description">{this.field().secondaryDescription}</p>;
    }
    return null;
  }

  errors() {
    const extractErrors = (errors) => {
      if (typeof errors === 'function') {
        return extractErrors(
          errors(
            this.props.values[this.field().key],
            this.field(),
            this.props.values
          )
        );
      }
      if (Array.isArray(errors)) {
        return errors;
      }
      if (errors) {
        return [errors];
      }
      return [];
    };
    return extractErrors.bind(this)(this.field().errors); // not sure why I need to bind this here.
  }

  renderErrors() {
    const errors = this.errors();
    if (!errors.length) {
      return null;
    }
    return (
      <ul className="errors-list">
        {errors.map((err) => {
          return <li key={err}>* {err}</li>;
        })}
      </ul>
    );
  }

  render() {
    if (this.field()) {
      return (
        <div className={this.renderClasses()}>
          {this.field().label ? (
            <label htmlFor={this.renderFor()} className="control-label">
              <span>{this.field().label}</span>
              {this.renderRequired()}
            </label>
          ) : null}
          {this.renderBeta()}
          {this.renderDescription()}
          {this.renderField()}
          {this.renderSecondaryDescription()}
          {this.renderErrors()}
        </div>
      );
    }
    return null;
  }
}

GeckoField.defaultProps = {
  field: {},
  values: {},
  handler: () => {},
  onBlur: () => {},
};

GeckoField.propTypes = {
  field: PropTypes.shape(GeckoFieldModel).isRequired,
  handler: PropTypes.func,
  onBlur: PropTypes.func,
};

export default GeckoField;
